import React from 'react';

import TabPanelContent from './QCTabPanelContent';

import './QCTabPanel.scss';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

export function isHidden(props: TabPanelProps) {
    return props.value !== props.index;
}

export default function QCTabPanel(props: TabPanelProps) {
    const {
        index,
        value,
        children,
    } = props;
    
    return (
        <div
            role="tabpanel"
            className="qc-tab-panel"
            hidden={isHidden(props)}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
        >
            <TabPanelContent
                index={index}
                value={value}
            >
                {children}
            </TabPanelContent>
        </div>
    );
}

QCTabPanel.defaultProps = {
    children: null,
};
